import { httpInternal, httpProxy } from "../api";

// async function login(credentials: UserCredentials) {
//   // return await http.post<APIResponse<Object>>("login", credentials);
//   return await httpProxy.post("login", credentials);
// }

// async function subscribeEmail(email: string) {
//   // return await http.post<APIResponse<Object>>("login", credentials);
//   return await httpProxy.post("subscribers", email);
// }

async function createCheckoutSession(productId: number, stripeCustomerId: string | null, isTrialEligible: boolean, isAnnual?: boolean, locale?: string) {
  return await httpInternal.post("create-checkout-session", {
    productId: productId,
    stripeCustomerId: stripeCustomerId,
    isTrialEligible: isTrialEligible,
    isAnnual: isAnnual,
    locale: locale
  });
}

async function getCheckoutStatus(checkoutSessionId: string) : Promise<any> {
  return await httpProxy.get(`checkout/status/${checkoutSessionId}`);
}

async function getCustomerPortalSession(stripeCustomerId: string, locale?: string) {
    const params = new URLSearchParams({ stripeCustomerId });
    if (locale) params.set('locale', locale);
    return await httpInternal.get("customer-portal-session?" + params.toString());
}

async function activateTrialSubscription() {
  return await httpProxy.post('subscriptions/activate-trial', {});
}

async function upgradeToYearlyPlan() {
  return await httpProxy.post('subscriptions/upgrade-to-yearly', {});
}

export default {
  createCheckoutSession,
  getCheckoutStatus,
  getCustomerPortalSession,
  activateTrialSubscription,
  upgradeToYearlyPlan
};
